function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8337 22.78V37.1756H25.6404H29.4681",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.0647 22.8717H21.8813C21.1984 22.8656 20.5455 22.5905 20.0647 22.1062C19.5839 21.6218 19.3142 20.9675 19.3142 20.2855V17.0356H22.248",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1572 17.0586H19.3143V20.3085C19.3143 20.6481 19.2473 20.9844 19.1171 21.2981C18.987 21.6119 18.7962 21.897 18.5557 22.1371C18.3152 22.3773 18.0297 22.5678 17.7154 22.6978C17.4012 22.8277 17.0644 22.8946 16.7243 22.8946V22.8946C16.0413 22.8886 15.3884 22.6135 14.9076 22.1291C14.4269 21.6448 14.1571 20.9904 14.1572 20.3085V17.0586Z",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.315 17.0586H14.1571V20.3085C14.1571 20.6481 14.0901 20.9844 13.96 21.2981C13.8298 21.6119 13.639 21.897 13.3985 22.1371C13.158 22.3773 12.8725 22.5678 12.5583 22.6978C12.244 22.8277 11.9072 22.8946 11.5671 22.8946V22.8946C10.8842 22.8886 10.2313 22.6135 9.75048 22.1291C9.2697 21.6448 8.99997 20.9904 9 20.3085V19.3701C9 18.7631 9.24148 18.181 9.67133 17.7518C10.1012 17.3226 10.6842 17.0815 11.2921 17.0815L11.315 17.0586Z",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M40.9972 21.1781C40.9831 22.3953 40.6682 23.5903 40.0803 24.6568L33.548 36.7408C33.5028 36.864 33.4221 36.971 33.316 37.0484C33.21 37.1258 33.0833 37.1701 32.9521 37.1756H32.6999C32.5355 37.0932 32.4056 36.9554 32.3332 36.7866C30.3162 32.6441 27.7491 28.7992 25.755 24.611C25.2479 23.6206 24.944 22.5391 24.8611 21.4298C24.7994 20.2018 25.0353 18.9771 25.5487 17.8595C26.1841 16.3468 27.273 15.0676 28.6659 14.1977C29.9041 13.4466 31.3185 13.0342 32.767 13.002C34.2155 12.9699 35.6469 13.3191 36.9173 14.0146C38.0642 14.7166 39.0424 15.6621 39.7824 16.7839C40.6162 18.0952 41.0392 19.6253 40.9972 21.1781Z",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M32.952 23.6498C33.5947 23.6453 34.2217 23.4508 34.7539 23.091C35.2861 22.7312 35.6997 22.222 35.9425 21.6278C36.1853 21.0336 36.2465 20.3809 36.1184 19.752C35.9902 19.1231 35.6784 18.5462 35.2223 18.094C34.7662 17.6417 34.1863 17.3345 33.5556 17.2109C32.9249 17.0874 32.2717 17.1531 31.6783 17.3997C31.0849 17.6463 30.5779 18.0629 30.2212 18.5968C29.8646 19.1307 29.6743 19.7581 29.6743 20.3999C29.6803 21.2639 30.0283 22.0905 30.6423 22.6993C31.2564 23.3081 32.0866 23.6498 32.952 23.6498V23.6498Z",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4321 37.1757V27.2659H20.4832V37.1757",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var SvgDashboardNew = function SvgDashboardNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboardNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard-new.a3b8ebe5.svg";
export { ForwardRef as ReactComponent };